import { Button, EmptyState } from '@e2n/ui/v2';
import { RotationsplanCard } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/RotationsplanCard';
import { Header } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/Header';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { faArrowProgress, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function Uebersicht() {
  const { store } = useRotationsplanFeatureContext();
  const { t } = useTranslation();
  const {
    data: {
      uebersicht: { rotationsplaene },
    },
  } = store;

  return (
    <div className="flex flex-col gap-6 items-start">
      <Header />
      <div
        key="uebersicht"
        className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {rotationsplaene.length < 1 ? (
          <div className="w-full h-full bg-backgrounds-primary rounded-xl p-8 flex justify-center items-center">
            <EmptyState
              icon={
                <FontAwesomeIcon
                  icon={faArrowProgress}
                  className="text-neutrals-v2-700"
                />
              }
              title={t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.keinPlan.title',
              )}
              description={t(
                'domain.mitarbeiter.rotationsplan.rotationsplaene.keinPlan.subtitle',
              )}
            />
          </div>
        ) : (
          rotationsplaene.map((plan) => (
            <Link
              key={plan.id}
              className="min-w-0"
              to={`/mitarbeiter/rotationsplan/${plan.id}`}>
              <RotationsplanCard key={plan.id} rotationsplan={plan} />
            </Link>
          ))
        )}
      </div>
      <Button
        asChild
        iconOnly
        className="absolute md:hidden right-4 z-49 bottom-16 shadow-xl">
        <Link to={`/mitarbeiter/rotationsplaene/uebersicht/create`}>
          <FontAwesomeIcon icon={faPlus} />
        </Link>
      </Button>
    </div>
  );
}
